export default "__VITE_ASSET__fD9wQ6fc__"